export const DEFAULT_OWNER = "Reveleer";
export const ORG_OPTION = "O";
export const CLIENT_OPTION = "C";
